import { useEffect, useState } from "react";

export function useSearch(initialValue) {
  const [searchKey, setSearchKey] = useState(initialValue ?? "");
  const [debouncedSearchKey, setDebouncedSearchKey] = useState(searchKey);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchKey(searchKey);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchKey, 500]);

  const onChange = (val) => setSearchKey(val);

  const clearSearch = () => setSearchKey("");

  return {
    searchKey,
    setSearchKey,
    onChange,
    clearSearch,
    debouncedSearchKey,
  };
}
